// extracted by mini-css-extract-plugin
module.exports = {"placeholder-row":"styles_placeholder-row__2qfBY"};